/* Debora Sommelier – V1 bootstrap
   Reads taxonomy from #debora-taxonomy, compiles alias maps once,
   scans current page (product page now; collections next), and exposes
   matches via window.DEBORA for UI/filters/badges. */

(function () {
  // ---------- Utilities ----------
  const byId = (id) => document.getElementById(id);
  const safeJSON = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch { return null; } };

  const normalize = (s) =>
    (s || "")
      .toLowerCase()
      .normalize("NFD").replace(/\p{Diacritic}/gu, "")     // remove accents (satèn -> saten)
      .replace(/['’`]/g, "")                               // strip apostrophes
      .replace(/[^a-z0-9+ ]/g, " ")                        // keep alnum/+
      .replace(/\s+/g, " ")                                // single spaces
      .trim();

  const wordBoundary = (s) => new RegExp(`\\b${s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");

  // ---------- Load taxonomy ----------
  const taxTag = byId("debora-taxonomy");
  if (!taxTag) return;

  const taxonomy = safeJSON(taxTag) || { terms: [], extra_raw: [] };
  const UPDATED = taxonomy.updated || "";
  const TERMS = Array.isArray(taxonomy.terms) ? taxonomy.terms : [];
  const EXTRA = Array.isArray(taxonomy.extra_raw) ? taxonomy.extra_raw : [];

  // Cache-bust if taxonomy changed
  const CACHE_KEY = `debora:compiled:${UPDATED}`;
  /** compiled = { aliasToSlug: Map, slugToTerm: Map, extraSet: Set, updated } */
  let compiled = null;
  try { compiled = JSON.parse(localStorage.getItem(CACHE_KEY)); } catch {}
  if (!compiled) {
    // Build alias→slug map and slug→term map
    const aliasToSlug = {};
    const slugToTerm = {};
    TERMS.forEach((t) => {
      slugToTerm[t.slug] = t;
      const base = [t.it, t.en].filter(Boolean);
      const al = Array.isArray(t.aliases) ? t.aliases : [];
      const all = [...base, ...al].map(normalize).filter(Boolean);
      // Deduplicate and ignore 1-char tokens
      [...new Set(all)].forEach((a) => { if (a.length > 1) aliasToSlug[a] = t.slug; });
    });
    const extraSet = new Set(EXTRA.map(normalize).filter(Boolean));
    compiled = { aliasToSlug, slugToTerm, extraSet, updated: UPDATED };
    // Clean old caches by namespace
    Object.keys(localStorage).forEach((k) => { if (k.startsWith("debora:compiled:")) localStorage.removeItem(k); });
    localStorage.setItem(CACHE_KEY, JSON.stringify(compiled));
  }

  // ---------- Text extraction (Product page v1) ----------
  const productJSON = safeJSON(byId("debora-product"));
  const haystackParts = [];

  if (productJSON) {
    haystackParts.push(productJSON.title || "");
    haystackParts.push(productJSON.vendor || ""); // Brand Name
    if (Array.isArray(productJSON.tags)) haystackParts.push(productJSON.tags.join(" "));
    if (productJSON.body_html) {
      // strip HTML
      const div = document.createElement("div");
      div.innerHTML = productJSON.body_html;
      haystackParts.push(div.textContent || "");
    }
    // variant titles (grape/style often hide here)
    if (Array.isArray(productJSON.variants)) haystackParts.push(productJSON.variants.map(v => v.title).join(" "));
  } else {
    // non-product pages: fallback to page title + visible text (lightweight)
    haystackParts.push(document.title);
  }

  const hayRaw = haystackParts.join(" ");
  const hayNorm = normalize(hayRaw);

  // ---------- Matching ----------
  const foundSlugs = new Set();
  const foundExtras = new Set();

  // 1) exact alias hits with word boundaries (on normalized haystack)
  const checked = new Set();
  Object.keys(compiled.aliasToSlug).forEach((alias) => {
    if (checked.has(alias)) return;
    checked.add(alias);
    if (!alias) return;
    // boundary check using normalized haystack and alias
    const re = wordBoundary(alias);
    if (re.test(hayNorm)) foundSlugs.add(compiled.aliasToSlug[alias]);
  });

  // 2) extra_raw simple tags (exact, normalized, boundary-ish)
  compiled.extraSet.forEach((x) => {
    const re = wordBoundary(x);
    if (re.test(hayNorm)) foundExtras.add(x);
  });

  // 3) Treat product vendor as brand if present
  if (productJSON && productJSON.vendor) {
    const vn = normalize(productJSON.vendor);
    // try a direct alias→slug hit from vendor
    if (compiled.aliasToSlug[vn]) foundSlugs.add(compiled.aliasToSlug[vn]);
  }

  // Group results by type for easy UI/filtering
  const grouped = {};
  [...foundSlugs].forEach((slug) => {
    const t = compiled.slugToTerm[slug];
    if (!t) return;
    (grouped[t.type] ||= []).push({ slug, it: t.it, en: t.en });
  });
  if (foundExtras.size) grouped.extra = [...foundExtras];

  // Expose globally for now (V1). Your UI components can read from here.
  window.DEBORA = {
    updated: compiled.updated,
    matches: grouped,
    // helpers for future UI
    get(type) { return grouped[type] || []; },
    getAll() { return JSON.parse(JSON.stringify(grouped)); }
  };

  // Example: add small badges on product page (optional, safe no-op on other pages)
  try {
    if (productJSON) {
      const host = document.querySelector("[data-product-information]") || document.querySelector("main, .product");
      if (host) {
        const badge = document.createElement("div");
        badge.setAttribute("id", "debora-badges");
        badge.style.marginTop = "12px";
        badge.style.fontSize = "13px";
        badge.style.lineHeight = "1.35";
        const pills = [];
        ["style","region","grape","method","ethic","descriptor","intent","pack","doc"].forEach((k) => {
          (grouped[k] || []).slice(0, 3).forEach((it) => pills.push(it.it || it.en));
        });
        if (pills.length) {
          badge.innerHTML = `<strong>Sommelier:</strong> ${pills.map(p => `<span style="display:inline-block;border:1px solid #ccc;padding:2px 6px;border-radius:999px;margin-right:6px;margin-top:6px;">${p}</span>`).join(" ")}`;
          host.appendChild(badge);
        }
      }
    }
  } catch {}
})();
